import { useLayoutEffect, useEffect, useState } from "react";
import { defaultColumnColors } from "../EmissoraColor/EmissoraColor";
import { useTranslation } from "react-i18next";

export function MediaGraphicPie({ heading, lastAudience, data, divMinute, audienceMediaFirstTable }) {
  const RootComponent = document.getElementById("root");
  const pUiScreenWidth = parseFloat(RootComponent ? getComputedStyle(RootComponent).width : '0');
  const pColumnsCustomColors = heading?.enabled?.length ? heading.enabled.map(x => x.color) : [];

  let columnColors = pColumnsCustomColors ?? defaultColumnColors;
  let divDate = document.getElementsByClassName("divDate")[0];
  let tableTitleHeight = parseFloat(divDate !== undefined ? getComputedStyle(divDate).height : '0');
  const { t } = useTranslation();

  let GridAudienceColumn = document.getElementsByClassName("Media_cellRows")[0];
  let chartWidth = parseFloat(GridAudienceColumn !== undefined ? getComputedStyle(GridAudienceColumn).width : '0');
  let firstHeader = document.getElementsByClassName("Media_headerFirst")[0];
  let firstHeaderWidth = parseFloat(firstHeader !== undefined ? getComputedStyle(firstHeader).width : '0');

  const chartHeight = 264;

  const [widthPage, setWidthPage] = useState(window.innerWidth);

  function updateWidth() {
    setWidthPage(window.innerWidth);
  }

  window.addEventListener("resize", updateWidth);
  useLayoutEffect(() => { }, []);

  useEffect(() => { }, [widthPage]);

  function parseData(valueString) {
    const values = valueString ? valueString.split('|') : ['', ''];
    const parsedValues = values.map(value => parseFloat(values[0]));
    return [
      isNaN(parsedValues[0]) ? 0 : parsedValues[0],
      isNaN(parsedValues[1]) ? 0 : parsedValues[1]
    ];
  }

  let emptyCell = (
    <td key="first" style={{
      verticalAlign: "bottom",
      padding: "0px",
      height: `${chartHeight}px`,
      width: `${Math.round(firstHeaderWidth)}px`,
      position: "relative",
      minWidth: `${Math.round(firstHeaderWidth)}px`,
    }}></td>
  );
  let lineChartLength = 30;

  let firstRowCells = data[0] ? data[0].slice(0, -1) : [];

  let columns = firstRowCells.length > 0 ? firstRowCells.map(() => []) : [];
  
  let maxValue = 0;
  data.forEach((row, rowIndex) => {
    if (rowIndex >= lineChartLength) {
      return;
    }
    row = row.slice(0, -1);
    row.forEach((cell, index) => {
      let value = parseData(cell)[0];
      if (Array.isArray(columns[index])) {
        columns[index].push(value);
      } else {
        console.warn('some rows have more columns than expected');
      }
      maxValue = Math.max(maxValue, value);
    });
  });
  let textData = [],
    dataObj: any = [];

  firstRowCells.forEach(function (cellValue) {
    dataObj.push(parseData(cellValue));
  });

  let pieValues: any = [];
  let pieSum = 0;
  let lastPiePieceValue = 100;

  let row = (
    <tr
      style={{
        height: chartHeight
      }}
    >
      {emptyCell}
      {heading.enabled.map((column, key) => {
        let backgroundColor = columnColors[(key % columnColors.length)];
        let values = dataObj[key] ?? [0, 0];
        pieValues.push(values[0]);
        pieSum += values[0] < 100 ? values[0] : 0;
        lastPiePieceValue -= values[0] === 100 ? 0 : values[0];

        let valuePixels = 10;
    
        let svgLine: any = null;
        let lineDot: any = null;
        let mainTextValue: any = null;
        let secondaryTextValue: any = null;


        return (
          <td key={key} style={{
            position: 'relative',
            verticalAlign: 'bottom',
            width: chartWidth - 1,
            minWidth: chartWidth - 1
          }}>
            <div
              style={{
                backgroundColor: backgroundColor,
                position: 'relative',
                bottom: 0,
                width: '100%',
                height: valuePixels
              }}
            >
              {mainTextValue}
              {secondaryTextValue}
              {svgLine}
              {lineDot}
            </div>
          </td>
        );
      })}
    </tr>
  );

  let pieChartWidth = pUiScreenWidth;
  let pieChartHeight = chartHeight - 18;
  const centerX = pieChartWidth / 2;
  const centerY = pieChartHeight / 2;
  const rx = pieChartHeight / 2 - tableTitleHeight;
  const ry = pieChartHeight / 2 - tableTitleHeight;
  let startAngle = 0;
  let endAngle = 0;

  let pieChart = pieSum > 0 && (
    <svg
      data-testid="chartPie" 
      width={pieChartWidth}
      height={pieChartHeight}
      style={{
        position: 'fixed',
        top: 120,
      }}
    >
      {pieValues.map((value, index) => {
        if (value === 100) { return } 
        if (pieSum === 0) { return } 
        let percent = value / pieSum;
        let backgroundColor = columnColors[(index % columnColors.length)];
        endAngle = startAngle + percent * (2 * Math.PI);
        if (percent > 0.999) {
          
          endAngle *= 0.999;
        }
        let x1 = (centerX + rx * Math.cos(startAngle));
        let x2 = (centerX + rx * Math.cos(endAngle));
        let y1 = (centerY + rx * Math.sin(startAngle));
        let y2 = (centerY + rx * Math.sin(endAngle));
        let largeArc = percent > 0.5 ? 1 : 0;
        let piePath = `M${centerX},${centerY} L${x1},${y1} A${rx} ${ry} 0 ${largeArc} 1 ${x2} ${y2} z`;

        startAngle = endAngle;
        return (
          <path
            key={index}
            d={piePath}
            strokeWidth={1}
            fill={backgroundColor}
            stroke='none'
          >
          </path>
        );
      })}
    </svg>
  );

  let pieChartWithLabel = (
    <div>
      {pieChart}

      <p className="infoPie">{t("chart.pieChartLabel")}</p>
    </div>
  );


  const contentGraphic = (
    <div
      id="column-bars"
      style={{
        width: pUiScreenWidth
      }}
    >
      <table style={{ marginLeft: 1 }}>
        <tbody>

          {row}
        </tbody>
      </table>
      {pieChartWithLabel}
    </div>
  );

  return (
    <div
      id="chartPieContainer"
      style={{
        height: "264px",
        overflow: "hidden",
        marginRight: "1%",
        display: "flex"
      }}
    >
      
      {contentGraphic}
    </div>
  );
}